import { useTranslation } from 'react-i18next';
import { focusFirstProblem, saveProblemLine, type SaveProblem } from './portalCustomerStaffModel';

/**
 * W-08c: the ONE summary of a refused save - every problem, sticky at the top
 * of the dialog body (so it is on screen wherever the body is scrolled). Each
 * line moves the focus to its field.
 */
export default function SaveProblemsSummary({ problems }: { problems: SaveProblem[] }) {
  const { t } = useTranslation();
  if (problems.length === 0) return null;
  return (
    <div role="alert" data-save-problems="" className="sticky top-0 z-10 rounded-lg border border-danger-200 bg-danger-50 px-3 py-2.5 text-sm text-danger-700 shadow-sm">
      <p className="font-medium">{t('contacts.cannotSaveYet')}</p>
      <ul className="mt-1 list-disc ps-5">
        {problems.map((p) => (
          <li key={p.id + p.key}>
            <button type="button" className="text-start underline underline-offset-2" onClick={() => focusFirstProblem([p.id])}>
              {saveProblemLine(p, t as never)}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
